import Form from '../component/um/register-external/Form'

import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Container from '@material-ui/core/Container'
import { Paper, Typography } from '@material-ui/core'
import useTranslate from '../i18n/useTranslate'
import useRegisterExternal, { Form as FormT } from '../services/um/useRegisterExternal'
import { useState, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import { RoutePath } from '../router/routesConfig'
import { encryption } from '../utilities/encryption'

import Dialog, { DialogType } from '../control/dialog/dialog'
import LayoutPublic from '../component/web/layout/layoutPublic'
// import usePDPA from '../services/authen/usePDPA'
import useCheckEmail from '../services/um/useCheckEmail'
import Acceptance from '../component/um/register-external/Acceptance'

const RegisterExternal = () => {
    const classes = useStyles({})
    const translate = useTranslate()
    const history = useHistory()
    // const lang = translate.languageStore.currentLanguage as 'th' | 'en'

    const { post } = useRegisterExternal()
    // const { get } = usePDPA()
    const { postCheck } = useCheckEmail()

    const [configDialog, setConfigDialog] =
        useState<Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>>()
    const dialogTwoRef = useRef<Record<string, Function>>()
    const [displayPW, setDisplayPW] = useState(false)
    const [displayCfPW, setDisplaCfyPW] = useState(false)
    // eslint-disable-next-line
    const [PDPA, setPDPA] = useState<string>('')
    // eslint-disable-next-line
    const [openPDPA, setOpenPDPA] = useState(false)

    const [canUse, setCanUse] = useState<'pass' | 'failed' | undefined>(undefined)

    const [isOpen, setIsOpen] = useState(false)
    const [bufferData, setBufferData] = useState<any>()

    // const fetchPDPA = async () => {
    //     const result = await get()
    //     if (result) {
    //         setPDPA(result[lang])
    //     }
    // }

    const onRefDialogTwo = (func: Record<string, Function>) => {
        dialogTwoRef.current = func
    }

    // const save = async (values: FormT) => {
    //     const format = {
    //         ...values,
    //         password: encryption(values.password),
    //         PDPA: true,
    //     }

    //     const result = await post(format)

    //     if (result) {
    //         setConfigDialog({
    //             title: translate.get('ALERT.TITLE.NOTIFICATION'),
    //             content: translate.get('UM.EXTERNAL-REGISTER.DIALOG.REGISTER_SUCCESS'),
    //             type: 'alert-message',
    //             onAfterClose: onBack,
    //         })
    //     }
    // }

    const onClickAccept = async () => {
        const format = {
            ...bufferData,
            password: encryption(bufferData.password),
            PDPA: true,
        }

        const result = await post(format)

        if (result) {
            setConfigDialog({
                title: translate.get('ALERT.TITLE.NOTIFICATION'),
                content: translate.get('UM.EXTERNAL-REGISTER.DIALOG.REGISTER_SUCCESS'),
                type: 'alert-message',
                onAfterClose: onBack,
            })
        }
        dialogTwoRef.current?.openDialog()
    }

    const onClickClose = () => {
        setIsOpen(false)
    }

    const onSubmit = async (values: FormT) => {
        if (canUse !== 'pass') {
            setConfigDialog({
                title: translate.get('ALERT.TITLE.NOTIFICATION'),
                content: translate.get('UM.EXTERNAL-REGISTER.DIALOG.INVALID_EMAIL'),
                type: 'alert-message',
            })

            dialogTwoRef.current?.openDialog()
        } else {
            if (values.uploadFile?.[0].uploadFileObj.fileList.length < 1) {
                setConfigDialog({
                    title: translate.get('ALERT.TITLE.NOTIFICATION'),
                    content: translate.get('ALERT.CONTENT.UPLOAD_FILE_AT_LEAST_1_FILE'),
                    type: 'alert-message',
                })
                dialogTwoRef.current?.openDialog()
            } else {
                setBufferData(values)
                setIsOpen(true)
            }
        }
    }

    const onSwitchPW = () => {
        setDisplayPW(!displayPW)
    }

    const onSwitchCfPW = () => {
        setDisplaCfyPW(!displayCfPW)
    }

    const onChangeMobilePhone = (val: string, fnCallback: (valBack: string) => void) => {
        if (val) {
            fnCallback(val.replace(/[^\d]/g, '').slice(0, 20))
        }
    }

    const onBack = () => {
        history.push(RoutePath.login)
    }

    const onClickCheck = async (value: string) => {
        const isChkErrorFormatEmail = onChkEmail(value)
        if (!isChkErrorFormatEmail) {
            if (!value) {
                setCanUse(undefined)
                return
            }

            const result = await postCheck(value, 1)

            if (result.message === 'pass') {
                setCanUse('pass')
                return
            }

            if (result.cunet) {
                setConfigDialog({
                    title: translate.get('ALERT.TITLE.NOTIFICATION'),
                    content: translate.get('ALERT.CONTENT.ACCOUNT_BELONGS_CUNET'),
                    // 'บัญชีนี้เป็นของ CU-NET หากท่านมีบัญชีของ CU-NET อยู่แล้ว สามารถ Login เพื่อเข้าสู่ระบบโดยไม่ต้องลงทะเบียนผู้วิจัย',
                    type: 'alert-message',
                    // onAfterClose: onBack,
                })
                setCanUse('failed')
                dialogTwoRef.current?.openDialog()

                return
            }

            if (result.message !== 'pass') {
                setConfigDialog({
                    title: translate.get('ALERT.TITLE.NOTIFICATION'),
                    content: translate.get('UM.EXTERNAL-REGISTER.DIALOG.PLEASE_RETYPE_EMAIL'),
                    type: 'alert-message',
                    // onAfterClose: onBack,
                })
                setCanUse('failed')
                dialogTwoRef.current?.openDialog()

                return
            }
        }
    }

    const onChkEmail = (val: string) => {
        let error = false
        // eslint-disable-next-line
        if (val && !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(val)) {
            error = true
        }

        return error
    }

    const onChangeUsername = () => {
        setCanUse(undefined)
    }

    return (
        <LayoutPublic>
            <Container maxWidth="xl" className={classes.rootContainer}>
                <Grid container justify="center" alignContent="center" className={classes.root}>
                    <Grid item xs={12} md={10} lg={8} className={classes.item}>
                        <Paper className={classes.paper}>
                            <Grid container className={classes.container}>
                                <Grid item xs={12}>
                                    <img
                                        src={process.env.PUBLIC_URL + '/img/Chulalongkorn_University_Alt_Logo.svg.png'}
                                        width={'auto'}
                                        height={'60px'}
                                        alt="chula"
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <Typography className={classes.typo}>
                                        {translate.get('UM.EXTERNAL-REGISTER.TITLE')}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12}>
                                    <Form
                                        onClickSubmit={onSubmit}
                                        onClickDisplayPW={onSwitchPW}
                                        onClickDisplayCfPW={onSwitchCfPW}
                                        onChangeMobilePhone={onChangeMobilePhone}
                                        onClickBackLink={onBack}
                                        onClickCheck={onClickCheck}
                                        displayPW={displayPW}
                                        displayCfPW={displayCfPW}
                                        canUse={canUse}
                                        onChangeUsername={onChangeUsername}
                                    />
                                </Grid>
                                <Acceptance isOpen={isOpen} onClickAccept={onClickAccept} onClickClose={onClickClose} />
                                {/* <ModalPDPA open={openPDPA} consent={PDPA} onClose={onBack} onAccept={onAccept} /> */}
                            </Grid>
                            <Dialog onRef={onRefDialogTwo} {...configDialog} />
                        </Paper>
                    </Grid>
                </Grid>
            </Container>
        </LayoutPublic>
    )
}

const useStyles = makeStyles((theme) => ({
    rootContainer: {
        display: 'flex',
        alignItems: 'center',
        minHeight: 'calc(100vh - 96px)',
        [theme.breakpoints.down('sm')]: {
            margin: '0px',
            padding: '0px',
        },
    },
    root: {
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            height: '100%',
        },
    },
    item: {
        [theme.breakpoints.down('sm')]: {
            height: '100%',
        },
    },
    paper: {
        width: '100%',
        margin: '2rem 0px',
        [theme.breakpoints.down('sm')]: {
            margin: '0px',
        },
    },
    container: {
        padding: '1.5rem',
    },
    typo: {
        fontWeight: 'bold',
    },
}))

export default RegisterExternal
